import {Component, computed, ElementRef, ViewChild} from '@angular/core';
import {AppMenu} from './app.menu';
import {LayoutService} from '@/layout/service/layout.service';
import {RouterModule} from '@angular/router';
import {AppTopbar} from "@/layout/components/app.topbar";
import {CommonModule} from "@angular/common";

@Component({
    selector: '[app-sidebar]',
    standalone: true,
    imports: [CommonModule,AppMenu, RouterModule, AppTopbar],
    template: `<div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
        <div class="sidebar-header">
            <a class="logo" [routerLink]="['/']">
                <!-- <img class="logo-image" [src]="menuTheme() === 'light' ? '/layout/images/logo-dark.svg' : '/layout/images/logo-white.svg'" alt="diamond-layout" />
                <span class="app-name title-h7">DIAMOND</span> -->
                <img src="/layout/images/white-logo.png" class="h-[2.35rem]" alt="logo-white" />
            </a>
            <button class="layout-sidebar-anchor z-2" type="button" (click)="anchor()"></button>
        </div>

        <div #menuContainer class="layout-menu-container">
            <div app-menu></div>
        </div>
        <div app-topbar *ngIf="isHorizontal()"></div>
    </div>`,
})
export class AppSidebar {
    timeout: any = null;

    isHorizontal = computed(() => this.layoutService.isHorizontal());

    menuTheme = computed(() => this.layoutService.layoutConfig().menuTheme);

    @ViewChild('menuContainer') menuContainer!: ElementRef;

    constructor(
        public layoutService: LayoutService,
        public el: ElementRef
    ) {}

    onMouseEnter() {
        if (!this.layoutService.layoutState().anchored) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }

            this.layoutService.layoutState.update((state) => {
                if (!state.sidebarActive) {
                    return {
                        ...state,
                        sidebarActive: true
                    };
                }
                return state;
            });
        }
    }

    onMouseLeave() {
        if (!this.layoutService.layoutState().anchored) {
            if (!this.timeout) {
                this.timeout = setTimeout(() => {
                    this.layoutService.layoutState.update((state) => {
                        if (state.sidebarActive) {
                            return {
                                ...state,
                                sidebarActive: false
                            };
                        }
                        return state;
                    });
                }, 300);
            }
        }
    }

    anchor() {
        this.layoutService.layoutState.update((state) => ({
            ...state,
            anchored: !state.anchored
        }));
    }
}
